






























































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
import { dialogPanel } from "@/components";
import { TbStocktaking } from '@/http/api_TbStocktaking';
@Component({
    components: {dialogPanel},
}) 
export default class unFinishProduct extends Vue {
   
    public $refs!: {
       
    };

    show=false;

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    allBeforeTotal = 0;
    currentPage=1
    totalStock=0;

   
    /**已盘点商品规格id */
    ids="";

    userInfo:any={};
    form:any={};

    searchValue={
        skip:0,
        count:10
    }

    async mounted() {
        
    }
    async created() {
    
    }
    showFun(val){
        this.userInfo = JSON.parse(localStorage.getItem('padShopInfo')); 
        this.ids = val;
        this.getList();
        this.show = true;
    }
    closeFun(){
        this.show = false;
    }
    saveFun(){
        let val = {
            form:this.form,
            val:false
        }
        this.$emit('unConfirm',{
            form:this.form,
            val:false
        });
    }

    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.searchValue.count=10;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
        if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
        }
        let s = this.searchValue.count;
        let res = await  TbStocktaking.GetNotStocktakingGoodItemListV2(
            Object.assign({},this.searchValue,{
                 shopno:this.userInfo.shopNo,ids:this.ids
            })
        )
        this.form = res;
        this.list = this.searchValue.skip==0? res.items:this.list.concat(res.items);
        this.total  = res.totalCount;
        this.allBeforeTotal = res.allBeforeTotal;
        this.currentPage++;
        this.searchValue.skip = (this.currentPage - 1) * s;
        this.loading = false;
        if (this.list.length >= this.total) {
            this.finished = true;
            console.log('list',this.list);
        }
    }
    /**获取商品列表 */
    async getList(){
        this.onRefresh();
    }
    /**触底加载 */
    // async getList(){
    //         let res = await TbStocktaking.GetNotStocktakingGoodItemList({
    //             shopno:this.userInfo.shopNo,
    //             ids:this.ids
    //         })
    //         this.form = res;
    //         this.list = res.items;
    //         this.total  = res.totalCount;
    //         this.allBeforeTotal = res.allBeforeTotal;
    // }


}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/components/unFinishProduct.vue